import { useTranslation } from "react-i18next"

import { ProjectImportError } from "shared/types/__generated__/graphql"
import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface XlsxImportErrorHintProps {
  id: string
  errors?: ProjectImportError[]
}

export function XlsxImportErrorHint({ id, errors }: XlsxImportErrorHintProps) {
  const { t } = useTranslation()

  if (!errors || errors.length === 0) return null

  return (
    <Hint.Root
      id={id}
      variant="danger"
      className="new-project-overlay__xlsx-hint"
    >
      <Hint.Icon name={IconName.WARNING} />
      <Hint.Content>
        <Hint.Title>{t("NewProjectOverlay.XlsxUpload.ErrorTitle")}</Hint.Title>
        {errors.map((error, index) => (
          <Hint.Text key={error.rowIndex ?? index}>
            {error.rowIndex != null
              ? `${t("NewProjectOverlay.XlsxUpload.ErrorRow", {
                  row: error.rowIndex
                })}: ${error.errors?.join(", ")}`
              : error.errors?.join(", ")}
          </Hint.Text>
        ))}
      </Hint.Content>
    </Hint.Root>
  )
}
